import styled from '@emotion/styled';
import { Form } from 'formik';

import { Button } from '@components/shared/button';

export const NoSessionsMsgWrap = styled.h2({
  paddingTop: '25px',
  borderTop: '1px solid #E1E1E1',
});

export const SessionListWarap = styled.div`
  max-width: 590px;
  margin: auto;
  padding-top: 40px;

  @media (max-width: 599px) {
    padding-top: 20px;
  }
`;

export const ListContainer = styled.div({
  // marginTop: '20px',
  textAlign: 'center',
  marginRight: 'auto',
  marginLeft: 'auto',
});

export const ListWrapper = styled.ul({
  listStyle: 'none',
  textAlign: 'left',
  fontSize: '16px',
  padding: 0,
  margin: 0,
  borderTop: '1px solid #E1E1E1',
});

export const ListItem = styled.li<{ gTemplateCol?: string }>`
  display: grid;
  grid-template-columns: ${props =>
    props.gTemplateCol ? props.gTemplateCol : '1fr 120px'};
  grid-gap: 20px;
  align-items: center;
  padding: 35px;
  border-bottom: 1px solid #e1e1e1;

  @media (max-width: 599px) {
    grid-template-columns: 1fr 120px;
    // grid-gap: 10px;
    // padding: 25px 0px;
    grid-gap: 10px;
    padding: 25px 0px;
    justify-content: space-between;
    display: grid;
  }
`;

export const DetailsMainWrapper = styled.span`
  display: grid;
  grid-template-columns: 50px 1fr;
  grid-gap: 22px;
  align-items: center;

  @media (max-width: 599px) {
    grid-template-columns: 45px 1fr;
    grid-gap: 8px;
  }
`;

export const DetailsWrapper = styled.span`
  margin-left: 15px;
  margin-top: 2px;
  width: 100%;

  @media (max-width: 599px) {
    margin-left: 0px;
    margin-top: 0px;
  }
`;

export const DetailsActionWrapper = styled.div`
  text-align: center;
`;

export const ListAvatar = styled.div`
  height: 50px;
  width: 50px;
  @media (max-width: 599px) {
    height: 45px;
    width: 45px;
  }
`;

export const ClassTypeText = styled.div({
  marginBottom: '10px',
});

export const TimeFilterList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  @media (max-width: 599px) {
    grid-template-columns: auto;
  }
`;

export const TimeFilterWrapper = styled.div({
  borderRadius: '8px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: ' white',
  textAlign: 'center',
  height: '85px',
});

export const FilterButton = styled(Button)({
  background: 'transparent',
  padding: 0,
  margin: 0,
  borderRadius: 0,
});

export const AllFilterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 16px;
  align-items: center;
  margin-top: 22px;
  padding: 0px 35px 30px;

  @media (max-width: 599px) {
    padding: 0px 0px 25px;
  }
`;

export const CalendarWrapper = styled.div`
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  margin-top: 22px;
  padding: 0px 25px;

  @media (max-width: 599px) {
    padding: 0px;
  }
`;

export const GuestInfo = styled(Form)`
  padding: 20px 40px 20px;
  min-width: 600px;
  box-sizing: border-box;

  > div {
    max-width: 600px;
  }

  @media (max-width: 599px) {
    padding: 20px;
    min-width: 300px;
  }
`;

export const SessionsCheckboxList = styled.li({
  padding: '16px 8px',
  borderBottom: '1px solid #E1E1E1',
});

export const SessionFilterListWrap = styled.div`
  padding: 20px 40px 95px;
  max-height: 60vh;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;

  @media (max-width: 599px) {
    padding: 20px 20px 95px;
  }
`;
